import { sanitizeHTML } from "@dfa/ui-platform-react";
import parse from "html-react-parser";

/**
 * Uses html-react-parser and sanitzeHTML to decode & sanitize sitecore html
 * @param {string} target The html that needs to be parsed
 * @returns Santized & parsed html
 */
export const parseSitecoreHTML = (target: string) => {
	return parse(parse(sanitizeHTML(target)) as string);
};
